import { Link } from "react-router-dom";
import Button from "./Button";
import styles from "./CategoryCard.module.css";

export default function CategoryCard({ title, cta, image, path }) {
  return (
    <article className={styles.card}>
      <img className={styles.image} src={image} alt={title} />
      <div className={styles.overlay} />
      <div className={styles.content}>
        <h3>{title}</h3>
        <Link to={path || "#"} className={styles.link}>
          <Button label={cta} variant="secondary" />
        </Link>
      </div>
    </article>
  );
}
